import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryBrowse() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-grid-fill" aria-hidden="true" /> 分类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">按分类找漫画</h2>
          <p className="mt-2 text-sm text-foreground-700">八大分类，总有一款适合你的口味</p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative flex h-32 items-end overflow-hidden rounded-lg bg-background-100 md:h-36"
              aria-label={`浏览${category.name}漫画`}
            >
              <img
                src={category.image}
                alt={`${category.name}漫画分类`}
                title={`${category.name}漫画分类-178漫画网`}
                className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="relative flex w-full items-end justify-between gap-2 px-4 pb-3.5">
                <div>
                  <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">{category.name}</h3>
                  <p className="mt-0.5 line-clamp-1 text-xs text-background-50/80">{category.description}</p>
                </div>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-50/15 text-background-50 backdrop-blur-sm transition-colors group-hover:bg-primary-500">
                  <i className={category.icon} aria-hidden="true" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}